export const THREADED_WASM_ISOLATION_ERROR =
  "Physics requires SharedArrayBuffer for MuJoCo threading, but this page is not cross-origin isolated. Check the Cross-Origin-Opener-Policy and Cross-Origin-Embedder-Policy headers for this deployment.";

export const THREADED_WASM_SHARED_MEMORY_ERROR =
  "Physics requires SharedArrayBuffer for MuJoCo threading, but this browser session does not expose SharedArrayBuffer.";

export const THREADED_WASM_WEBASSEMBLY_ERROR =
  "Physics requires WebAssembly for MuJoCo, but this browser session does not expose WebAssembly.";

export type ThreadedWasmSupportResult =
  | { ok: true }
  | {
      ok: false;
      reason:
        | "webassembly-unavailable"
        | "not-cross-origin-isolated"
        | "sharedarraybuffer-unavailable";
      message: string;
    };

type ThreadedWasmSupportGlobals = {
  crossOriginIsolated?: boolean;
  SharedArrayBuffer?: unknown;
  WebAssembly?: unknown;
};

const readRuntimeGlobals = (): ThreadedWasmSupportGlobals =>
  globalThis as unknown as ThreadedWasmSupportGlobals;

export function getThreadedWasmSupport(
  runtimeGlobals: ThreadedWasmSupportGlobals = readRuntimeGlobals()
): ThreadedWasmSupportResult {
  if (typeof runtimeGlobals.WebAssembly === "undefined") {
    return {
      ok: false,
      reason: "webassembly-unavailable",
      message: THREADED_WASM_WEBASSEMBLY_ERROR,
    };
  }

  if (runtimeGlobals.crossOriginIsolated !== true) {
    return {
      ok: false,
      reason: "not-cross-origin-isolated",
      message: THREADED_WASM_ISOLATION_ERROR,
    };
  }

  if (typeof runtimeGlobals.SharedArrayBuffer === "undefined") {
    return {
      ok: false,
      reason: "sharedarraybuffer-unavailable",
      message: THREADED_WASM_SHARED_MEMORY_ERROR,
    };
  }

  return { ok: true };
}
